import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import * as React from 'react';
import { SHIPMENTS_QUERY_PARAMS } from '../params';

interface Props {
  found: number;
  loading: boolean;
}

export const Results: React.FC<Props> = (props) => {
  const { searchParams } = useCustomSearchParams(SHIPMENTS_QUERY_PARAMS);
  const searched = searchParams.containerNumbers?.length || 0;
  const { found, loading } = props;

  const notFound = searched - found;

  if (!searched || loading) {
    return null;
  }

  return (
    <p>
      Showing results for {searched} containers
      {notFound > 0 && (
        <span>
          {' '}
          — <span className="text-red-900">{notFound} not found</span>
        </span>
      )}
    </p>
  );
};
Results.displayName = 'Shipments.Containers.Results';
